<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import MonitoraTable from './monitora-table'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/monitoramento_anim.json'
import moment from "moment";

import {clientesChart1, clientesChart2 } from "../components/data-simulados";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Monitoramento XML",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, MonitoraTable, Loader, Vue3Lottie },
  mounted() {
    console.log('mounted monCONitora-list_0')
    this.atualizaDataList()
  },
  data() {
    return {
      animationJson,
      title: 'Monitoramento XML',
      items: [
        {
          text: 'Estoque',
          href: '/',
        },
        {
          text: 'Monitoramento XML',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      monitorasList: null,
      monitoraSelecionadoKey: [],
      cliChart1: clientesChart1,
      cliChart2: clientesChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
      submittedPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
    }
  },

  methods: {
    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    atualizaDataList(){
      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment().add(-30, 'days').startOf('month')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      this.loadingList = true
      api.get(`${getBaseUrl()}api/monitoras`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter,
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data[0])
        this.monitorasList = res.data[0] || []
        const dtIniFormated = moment(this.dtIniFiltro)
            .format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro)
            .format('DD/MM/YYYY')
        this.title = `(${this.monitorasList.length}) Documentos (0 a processar): ${dtIniFormated} - ${dtFimFormated}`
        this.loadingList = false
        this.loadingGraph = false



        // api.post(`${getBaseUrl()}api/postnfeconsch`,  {
        //   idData: 472
        // }).then((res) => {
        //   console.log('then axios')
        //   console.log(res)
        // })



      });
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/monitora`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    baixarXML() {
      console.log('baixarXML')
      console.log(this.monitoraSelecionadoKey)
      api.post(`${getBaseUrl}api/`)
    },

    baixarZip() {
      console.log('baixarZip')
      console.log(this.monitoraSelecionadoKey)
      const chaves = this.monitoraSelecionadoKey.map(item => item.chave)
      api.post(`${getBaseUrl()}api/monitoraGeraDanfe`, {
        chavesNF: chaves
      }, {
        responseType: 'blob'
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        console.log(res.headers)
        const notasEncontradas = parseInt(res.headers['x-notasencontradas'],10)
        const notasFaltantes = parseInt(res.headers['x-notasfaltantes'],10)
        if (notasEncontradas === 0) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `Nenhuma nota encontrada para gerar DANFE.`,
            showConfirmButton: false,
            timer: 3000
          })
          return
        } 
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: `Danfe gerada com sucesso!\nNotas encontradas: ${notasEncontradas}\nNotas faltantes: ${notasFaltantes}`,
          showConfirmButton: false,
          timer: 3000
        })
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `danfe.zip`)
        document.body.appendChild(link)
        link.click()
      }).catch((error) => {
        // Add logging for error body
        if (error.response && error.response.data) {
          error.response.data.text().then(text => {
            try {
              const response = JSON.parse(text)
              const notasEncontradas = parseInt(response['notasEncontradas'],10)
              if (notasEncontradas === 0) {
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: `Nenhuma nota encontrada para gerar DANFE.`,
                  showConfirmButton: false,
                  timer: 3000
                })
                return
              } 
            } catch (parseError) {
              console.error('Erro ao parsear resposta de erro:', parseError)
            }
          }).catch(() => {
            console.error('Erro ao ler resposta de erro como texto')
          })
        }
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `Erro ao gerar o arquivo ZIP.`,
          showConfirmButton: false,
          timer: 3000
        })
      })
    },

    monitoraSelecionado(data) {
      console.log('monitoraSelecionado')
      console.log(data)
      this.monitoraSelecionadoKey = data
    },
  },
}
</script>

<template>
  <Layout>


    <span class="float-end" style="z-index: 1000; position: absolute; top: 10px; right: 250px;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="C">A processar</option>
                      <option value="CO">Processados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-8">
                <div class="text-sm-end">

                  <router-link :to="`/movcompra/importar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Novo Arquivo
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="baixarZip()">
                      <i class="mdi mdi-plus me-1"></i> Baixar Danfe
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <MonitoraTable v-if="!loadingList"
                           :monitorasList="monitorasList"
                           @monitoraSelecionado="monitoraSelecionado"
                           @deletareg="deletaReg"
                           />

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>


    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Semana</h4>
            <apexchart
                class="apex-charts"
                type="line"
                height="370"
                :series="cliChart1.series"
                :options="cliChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Fornecedores em Destaque</h4>
            <apexchart
                class="apex-charts"
                height="370"
                type="radialBar"
                dir="ltr"
                :series="cliChart2.series"
                :options="cliChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>

    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

  </Layout>
</template>

